import SupportTicketContainer from "../../Componant/SupportTicket";

const SupportTicket = () => {
  return (
    <div className="page-body">
      <SupportTicketContainer />
    </div>
  );
};

export default SupportTicket;
